import { render, staticRenderFns } from "./AttachmentUploader.vue?vue&type=template&id=0c02359c&scoped=true&"
import script from "./AttachmentUploader.vue?vue&type=script&lang=ts&"
export * from "./AttachmentUploader.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentUploader.vue?vue&type=style&index=0&id=0c02359c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c02359c",
  null
  
)

export default component.exports